import type { ExpirationStatus } from '@/modules/common/expiration-status'
import type { AllUserDocumentsQuery } from '@/modules/users'
import type { RelayNodeType } from '@/types/graphql'
import type { DateRange } from 'react-day-picker'

/** A row in the company-wide user documents table. */
export type UserDocumentRow = Exclude<
  RelayNodeType<AllUserDocumentsQuery['allUserDocuments']>,
  undefined
>

/** The filter state of the company-wide user documents page. */
export interface UserDocumentListFilterForm {
  /** Free-text search, sent to the backend as `q`. */
  q: string
  users: string[]
  categories: string[]
  responsibleUsers: string[]
  /** Empty string means "any status". */
  expirationStatus: ExpirationStatus | ''
  /** The expiry deadline window. */
  dateRange: DateRange | null
}

export const emptyUserDocumentListFilter: UserDocumentListFilterForm = {
  q: '',
  users: [],
  categories: [],
  responsibleUsers: [],
  expirationStatus: '',
  dateRange: null,
}
